import createSendStatusMiddleware from '/druid/createSendStatusMiddleware';
import createTimestampMiddleware from '/druid/createTimestampMiddleware';

import type { ActivityStatusMiddleware } from 'botframework-webchat-api';

export default function createCoreMiddleware(): ActivityStatusMiddleware[] {
  return [createSendStatusMiddleware(), createTimestampMiddleware()];
}
